var _a;
// QR 만료 기준 시간 (ms, 5분)
export var QR_DECREASE_FREQUENCY = 1000;
export var QR_EXPIRE_TIME = QR_DECREASE_FREQUENCY * 60 * 5;
export var QR_TYPE;
(function (QR_TYPE) {
    QR_TYPE["QR"] = "qr";
    QR_TYPE["PINCODE"] = "pincode";
})(QR_TYPE || (QR_TYPE = {}));
export var ACCOUNT_REQUEST_TYPE;
(function (ACCOUNT_REQUEST_TYPE) {
    ACCOUNT_REQUEST_TYPE["LOGIN"] = "login";
    ACCOUNT_REQUEST_TYPE["JOIN"] = "join";
})(ACCOUNT_REQUEST_TYPE || (ACCOUNT_REQUEST_TYPE = {}));
export var LOGIN_ID_PASSWORD_DISPLAY_TYPE;
(function (LOGIN_ID_PASSWORD_DISPLAY_TYPE) {
    LOGIN_ID_PASSWORD_DISPLAY_TYPE["LOGIN"] = "login";
    LOGIN_ID_PASSWORD_DISPLAY_TYPE["PASSWORD"] = "password";
})(LOGIN_ID_PASSWORD_DISPLAY_TYPE || (LOGIN_ID_PASSWORD_DISPLAY_TYPE = {}));
export var USER_TYPE;
(function (USER_TYPE) {
    // CJ_ONE_TVING = '',
    USER_TYPE["CJ_ONE"] = "CJ_ONE";
    USER_TYPE["TVING"] = "TVING";
    // TVING 테스트(모니터링) 계정
    USER_TYPE["TVING_TEST"] = "TVING_TEST";
    USER_TYPE["FACEBOOK"] = "FACEBOOK";
    USER_TYPE["TWITTER"] = "TWITTER";
    USER_TYPE["NAVER"] = "NAVER";
    USER_TYPE["KAKAO"] = "KAKAO";
    USER_TYPE["INSTAGRAM"] = "INSTAGRAM";
    USER_TYPE["APPLE"] = "APPLE";
})(USER_TYPE || (USER_TYPE = {}));
export var TICKET_TYPE;
(function (TICKET_TYPE) {
    // 구글인앱결제 상품
    TICKET_TYPE["AOS"] = "AOS";
    // 구글인앱결제 안드로이드 티비 상품
    TICKET_TYPE["ATV"] = "ATV";
    // 애플인앱결제 상품
    TICKET_TYPE["IOS"] = "IOS";
    // 네이버 플러스 멤버십 상품
    TICKET_TYPE["NAVER"] = "NAVER";
    // KT 번들 요금제 상품
    TICKET_TYPE["KT_BUNDLE"] = "KT_BUNDLE";
    // KT 부가서비스 상품
    TICKET_TYPE["KT_SERVICE"] = "KT_SERVICE";
    // LG 번들 요금제 상품
    TICKET_TYPE["LG_BUNDLE"] = "LG_BUNDLE";
    // LG 부가서비스 상품
    TICKET_TYPE["LG_SERVICE"] = "LG_SERVICE";
    // PC, MOWEB등 티빙에서 결제한 상품
    TICKET_TYPE["TVING"] = "TVING";
})(TICKET_TYPE || (TICKET_TYPE = {}));
export var PACKAGE_ID = {
    FREE: 2839994,
    LIGHT: 2915284,
    BASIC: 2610061,
    STANDARD: 2610161,
    PREMIUM: 2610062,
    VIP: 107,
};
export var PRODUCT_ID = {
    ANDROID_TV_STANDARD: 'standard_tv001',
    ANDROID_TV_PREMIUM: 'premium_tv001',
};
export var TICKET_TIER = {
    FREE: 0,
    LIGHT: 50,
    BASIC: 100,
    STANDARD: 200,
    PREMIUM: 300,
    VIP: 1000,
};
export var DURATION_TYPE;
(function (DURATION_TYPE) {
    DURATION_TYPE["MONTH"] = "MONTH";
    DURATION_TYPE["YEAR"] = "YEAR";
})(DURATION_TYPE || (DURATION_TYPE = {}));
export var TICKET_PACKAGE_ID_MAP = (_a = {},
    _a[PACKAGE_ID.FREE] = TICKET_TIER.FREE,
    _a[PACKAGE_ID.LIGHT] = TICKET_TIER.LIGHT,
    _a[PACKAGE_ID.BASIC] = TICKET_TIER.BASIC,
    _a[PACKAGE_ID.STANDARD] = TICKET_TIER.STANDARD,
    _a[PACKAGE_ID.VIP] = TICKET_TIER.VIP,
    _a[PRODUCT_ID.ANDROID_TV_STANDARD] = TICKET_TIER.STANDARD,
    _a[PACKAGE_ID.PREMIUM] = TICKET_TIER.PREMIUM,
    _a[PRODUCT_ID.ANDROID_TV_PREMIUM] = TICKET_TIER.PREMIUM,
    _a);
export var OFFER_TYPE = {
    UNKNOWN: 0,
    PPV: 1,
    TICKET: 2,
    PPV_AND_TICKET: 3,
    NOT_AVAILABLE: 4,
};
